import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import PulseLoader from "react-spinners/PulseLoader";

export default function SensorConfigMenu({ deviceID }) {
  const currentUser = useAuth().currentUser;
  const serverAddress = process.env.REACT_APP_SERVER_ADDRESS;
  const [token, setToken] = useState();
  const [headers, setHeaders] = useState();
  const [loading, setLoading] = useState(false);
  const options = ["Pumps", "Alarms", "Pressure Sensors"];
  const [selectedOption, setSelectedOption] = useState();
  const [selectedSensor, setSelectedSensor] = useState();
  const [pumps, setPumps] = useState([]);
  const [alarms, setAlarms] = useState([]);
  const [pressureSensors, setPressureSensors] = useState([]);
  const [displayedSensors, setDisplayedSensors] = useState([]);
  const [showNewSensor, setShowNewSensor] = useState(false);

  useEffect(() => {
    if (currentUser) {
      currentUser.getIdToken().then((token) => {
        setToken(token);
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (token) {
      setHeaders({
        headers: {
          token: token,
        },
      });
    }
  }, [token]);

  useEffect(() => {
    if (headers) {
      // getSensors();
    }
  }, [headers]);

  async function getSensors() {
    try {
      const res = await axios.post(
        `${serverAddress}/v3/deviceSensors/getSensorsForDevice`,
        { deviceID: deviceID },
        headers
      );

      console.log("res: ", res);

      if (res.data.pumps && res.data.pumps.length > 0) {
        setPumps(res.data.pumps);
      }

      if (res.data.alarms && res.data.alarms.length > 0) {
        setAlarms(res.data.alarms);
      }

      if (res.data.pressureSensors && res.data.pressureSensors.length > 0) {
        setPressureSensors(res.data.pressureSensors);
      }
    } catch (e) {
      console.log("error getting sensors: ", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption) {
        case "Pumps":
          setDisplayedSensors(pumps);
          break;
        case "Alarms":
          setDisplayedSensors(alarms);
          break;
        case "Pressure Sensors":
          setDisplayedSensors(pressureSensors);
          break;
        default:
          return;
      }
    } else if (displayedSensors.length > 0) {
      setDisplayedSensors([]);
    }
  }, [selectedOption]);

  async function handleAddButton() {
    console.log("add correct type of sensor");
    setShowNewSensor(true);
  }

  async function addNewSensor() {
    console.log("send new sensor to server");
  }

  return (
    <div className="max700">
      <PulseLoader
        color={"#ffffff"}
        loading={loading}
        size={20}
        className="loader"
      />
      {!loading && (
        <>
          {selectedOption ? (
            <div className="margin-t-b-2">
              {showNewSensor ? (
                <div>New sensor form</div>
              ) : (
                <>
                  <div className="flexRowSpaceBetween">
                    <h2>{selectedOption}</h2>
                    <button onClick={handleAddButton} className="spaceBtn">
                      ADD
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="sensorConfigMenuOptions">
              <>
                {options.map((option) => (
                  <div
                    className="sensorConfigMenuOptionButton"
                    key={option}
                    onClick={() => setSelectedOption(option)}
                  >
                    {option}
                  </div>
                ))}
              </>
            </div>
          )}
        </>
      )}
    </div>
  );
}
